import translationsJson from '../i18n/translations.json';

interface Translations {
  [key: string]: {
    [lang: string]: string;
  };
}

const translations: Translations = translationsJson;

export function getTranslation(key: string): string {
  const lang = document.documentElement.getAttribute('lang') || 'de-de';
  if (translations[key] && translations[key][lang]) {
    return translations[key][lang];
  }

  return (translations[key] && translations[key]['de-de']) || key;
}

export default () => {
  const htmlElement = document.documentElement;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
        onLangChange();
      }
    }
  });

  observer.observe(htmlElement, {
    attributes: true,
    attributeFilter: ['lang']
  });

  function onLangChange() {
    const a11yWidget = document.getElementById('a11y-widget');

    if (a11yWidget) {
      const translationElements: NodeListOf<HTMLElement> = a11yWidget.querySelectorAll('[data-translation-field="true"]');
    
      translationElements.forEach((translationElement) => {
        if (translationElement.dataset.translationKey) {
          translationElement.textContent = getTranslation(translationElement.dataset.translationKey);
        }
      });

      const ariaTranslationElements: NodeListOf<HTMLElement> = a11yWidget.querySelectorAll('[data-translation-aria-field="true"]');

      ariaTranslationElements.forEach((ariaTranslationElement) => {
        if (ariaTranslationElement.dataset.translationKey) {
          ariaTranslationElement.setAttribute('aria-label', getTranslation(ariaTranslationElement.dataset.translationKey));
        }
      });
    }
  }
}